module.exports = __webpack_public_path__ + "static/media/letter.9bba87ec.svg";